import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

// Navigate to `targetPath` and run `onArrive` exactly once — only if that navigation actually
// lands on `targetPath`. The listener unsubscribes on the first navigation (matching or not), so
// an abandoned or blocked push (e.g. a mounted Prompt cancels it) can't leave a listener dangling
// to fire on a later visit. Any pending listener is also torn down on unmount.
export const useOneShotNavigate = () => {
  const history = useHistory();
  const unlistenRef = useRef(null);

  useEffect(
    () => () => {
      unlistenRef.current?.();
    },
    []
  );

  return (targetPath, onArrive) => {
    unlistenRef.current?.();
    unlistenRef.current = history.listen((location) => {
      unlistenRef.current?.();
      unlistenRef.current = null;
      if (location.pathname !== targetPath) return;
      onArrive();
    });
    history.push(targetPath);
  };
};
